<template>
  <div class="area-wrapper">
    <div class="globus-area__title">
      {{ props.label }}
    </div>
    <div class="globus-area">
      <div
        ref="editable"
        contenteditable="true"
        spellcheck="false"
        class="content-editable scroll"
        :class="{
          'highlight-organisation': hoverType === 'organisation',
          'highlight-location': hoverType === 'location',
          'highlight-person': hoverType === 'person'
        }"
        :placeholder="props.placeholder"
        @focus="onFocus"
        @input="onInput"
        @paste="onPaste"
        @blur="onBlur"
      />

      <div class="globus-area__control">
        <!--    Счетчик скрыт    -->
        <!--        <div-->
        <!--          class="globus-area__symbol-count"-->
        <!--          :class="{ 'globus-area__symbol-count&#45;&#45;max': textLength > 10000 }"-->
        <!--        >-->
        <!--          {{ textLength }} / 10000-->
        <!--        </div>-->
        <div class="globus-area__control-wrapper">
          <ButtonNeutralSecondary
            :is-disabled="textLength === 0"
            @click="clearTextArea"
          >
            Очистить поле
          </ButtonNeutralSecondary>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import {ref, onMounted, watch, computed} from "vue";

const props = defineProps({
  modelValue: { type: String, required: true },
  isClicked: { type: Boolean, default: false },
  hoverType: { type: [String, null], required: true },
  label: { type: String, required: true },
  placeholder: { type: String, default: () => "" }
});
const emit = defineEmits(["update:modelValue", "action", "clear-text-area"]);

const editable  = ref(null);
const isFocused = ref(false);

const textLength = computed(() => {
  return normalizeNewlines(props.modelValue).replace(/<\/?[^>]+>/g, "").length;
});

onMounted(() => {
  if (editable.value) {
    onInput();
  }
});

// При фокусе
function onFocus() {
  isFocused.value = true;
}

// При потере фокуса
function onBlur() {
  isFocused.value = false;
}

function onInput() {
  let raw = editable.value.innerHTML
      .replace(/<br\s*\/?>/gi, "\n")
      .replace(/&nbsp;/g, " ")
      .replace(/<\/?[^>]+(>|$)/g, "")
      .replace(/\u00A0/g, " ");

  emit("update:modelValue", raw);
}

// При вставке текста очищаем html теги
function onPaste(e) {
  e.preventDefault();
  const text = normalizeNewlines((e.clipboardData || window.clipboardData).getData("text/plain"));
  document.execCommand("insertText", false, text);
  onInput();
}

function clearTextArea() {
  emit("clear-text-area", "");
}

function onAction() {
  emit("action", editable.value.innerHTML);
}

// Watcher для обработки выделенных объектов с бека
watch(
    () => props.modelValue,
    newVal => {
      if (!editable.value || isFocused.value) return;
      editable.value.innerHTML = newVal;
    }
);

// Убираем дублирование переносов
function normalizeNewlines(s) {
  return s
      .replace(/<br\s*\/?>/gi, "\n")
      .replace(/\r\n?/g, "\n")
      .replace(/\n$/, "");
}

// Вызов из родителя для получения innerText.
defineExpose({onAction});
</script>

<style scoped lang="scss">
.area-wrapper {
  display: flex;
  flex-direction: column;
  gap: 10px;
  min-height: 0;
  height: 100%;
  overflow: hidden;
}

.globus-area {
  display: flex;
  flex-direction: column;
  height: calc(100% - 40px);
  min-height: 0;
  padding: 20px;
  background: #fff;
  border-radius: 8px;
  gap: 4px;

  &__title {
    font-size: 16px;
    font-weight: 500;
    color: #212327;
  }

  &__control {

    &-wrapper {
      display: flex;
      gap: 10px;
    }

    display: flex;
    align-items: center;
    justify-content: flex-end;
  }

  &__symbol-count {
    font-size: 12px;
    font-weight: 400;
    color: #7b87a5;

    &--max {
      color: red;
    }
  }
}

.content-editable {
  all: unset;
  display: block;
  width: 100%;
  height: 100%;
  overflow: auto;
}

.content-editable:empty:before {
  content: attr(placeholder);
  color: #ccc;
}
</style>
